import { isValidIBAN } from 'ibantools';
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LinearInfoModal } from "../../components/cai-info-modal/LinearInfoModal";
import SinistroCardLinear from "../../components/cards/SinistroCardLinear";
import FilesUploadListCmp from "../../components/file/FilesUploadListCmp";
import FronteRetroFilesUploadListCmp from "../../components/file/FronteRetroFilesUploadListCmp";
import FronteRetroList from "../../components/file/FronteRetroList";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import InputCmp from "../../components/input/InputCmp";
import { RealtimeModal } from "../../components/modal/RealtimeModal";
import { LNextButton, SecondChoiseButton, } from "../../components/styled/Button.style";
import { LTitleIconSection, Section } from "../../components/styled/Containers.style";
import { Vspace } from '../../components/styled/Separators.style';
import { LPageTitle, LSimpleText, LSimpleTextSmall, LSmallPageTitle } from "../../components/styled/Text.style";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { selectCommunicationData } from "../../store";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { SIGNATURE_RESULTS, SignFolderOutcomeEnum } from "../../store/communication-data/sagas";
import { useAppSelector } from "../../store/hooks";
import { LinearFileTypeEnum } from "../../types/commonTypes";
import { CommunicationType, EventCommType, EventValueEnum, FileItemType } from "../../types/communication/communicationDataType";
import { checkDimensionsFileAdded, composeUrl, getListOfOnusSentFileIds } from "../../utils/utils";
import { uploadCreatedFileHandler } from "../../utils/utils-file";
import LinearPhone from './../../assets/img/linearPhone.svg';
import PageContainerCmp from "./../PageContainerCmp";
import { LinearHelpRequestText } from "./LinearHelpRequestText";

export const IbanStateAction = {
    UPDATE_STATE: '@@iban/UPDATE_STATE'
}

/* istanbul ignore next */
const OptionalDocumentsPageLinear = () => {
    const communicationData = useAppSelector(selectCommunicationData)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [openHelpModal, setOpenHelpModal] = useState(false)
    const { communication } = communicationData
    const { token, ibanAddress, companyName, linearConducenteInfo } = communication;

    const [witnessesStatsList, setWitnessesStatsList] = useState<FileItemType[]>(communication.witnessesStatsList)
    const [otherDocsList, setOtherDocsList] = useState<FileItemType[]>(communication.otherDocsList)
    const [ibanDocTxt, setIbanDocTxt] = useState<FileItemType[]>(communication.ibanDocTxt)

    const [iban, setIban] = useState<string>(ibanAddress)
    const disabledInput: boolean = !!ibanAddress

    const [formErrors, setFormErrors] = useState<any>()
    const alreadySentDocIds = useMemo(() => getListOfOnusSentFileIds(communication),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [communication?.token])

    /* istanbul ignore next */
    useEffect(() => {
        if (iban && !isValidIBAN(iban)) {
            setFormErrors({ "contact-info-iban": { message: 'Inserisci un IBAN valido.' } })
        }
        else setFormErrors(null)
    }, [iban])

    const uploadIbanFile = async (ibanValue: string): Promise<FileItemType[]> => {
        if (!ibanValue) return [];

        return new Promise((resolve, reject) => {
            const fileContent = `${ibanValue}`;
            const fileName = `${communication.caiData?.claimId}_iban.txt`;
            const blob = new Blob([fileContent], { type: 'text/plain' });
            const file = new File([blob], fileName, { type: 'text/plain', lastModified: Date.now() });

            const onFileAddedIban = (_file: FileItemType) => {
                setIbanDocTxt([_file]);
                resolve([_file]);
            }

            const onFileRemovedIban = (_file?: FileItemType) => {
                setIbanDocTxt([]);
                reject(new Error('Upload IBAN file failed'));
            }

            uploadCreatedFileHandler(file, 'IBAN-DOCUMENT', token, onFileRemovedIban, onFileAddedIban);
        });
    };

    const goToNextStepHandler = async () => {
        const nextPath = composeUrl(token, LINEAR_PATHS.END_THANK_YOU_PAGE, LINEAR_BASE_ROUTE);
        const resultEvent = new EventCommType({ value: EventValueEnum.LINEAR_UPLOADED_OPTIONAL_DOCS_AND_PROCEED });

        const baseData: CommunicationType = {
            ...communication,
            ibanAddress: iban,
        };
        // Se c'è un IBAN ma non è ancora stato caricato come file
        if (ibanDocTxt.length === 0 && iban) {
            const files = await uploadIbanFile(iban);
            baseData.ibanDocTxt = files;
        }
        dispatch(saveCommunicationAct({
            data: new CommunicationType(baseData),
            events: [resultEvent],
            callback: () => navigate(nextPath)
        }));
    };

    const goToHelp = () => {
        setOpenHelpModal(true)
    }

    //const urlParams = new URLSearchParams(window?.location?.search || '')
    //const isRequiringDocuments = urlParams.get('docs') === 'true'
    const isRequiringDocuments = communication?.events?.find((ev: EventCommType) => SIGNATURE_RESULTS.indexOf(ev?.metadata?.outcome as SignFolderOutcomeEnum) >= 0)

    return (
        <>

            <RealtimeModal
                companyName={communication?.companyName}
                modalOpened={openHelpModal}
                hTitle="CONTATTACI"
                hCloseButton={true}
                /* istanbul ignore next */
                onCloseHandler={() => setOpenHelpModal(false)}>
                <LinearInfoModal
                    close={() => setOpenHelpModal(false)}
                    additionalImage={LinearPhone}
                    text={<LinearHelpRequestText />}
                />
            </RealtimeModal>

            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={LINEAR_PATHS.OPTIONAL_DOCUMENTS_PAGE}
                removeNextBtn
            >

                <Section linear={true}>

                    <SinistroCardLinear />

                    <Vspace qty={2}></Vspace>

                    <LTitleIconSection>
                        <LPageTitle>DOCUMENTI OPZIONALI</LPageTitle>
                    </LTitleIconSection>

                    <Vspace></Vspace>

                    <LSimpleText className="left">Carica ulteriori documenti a supporto della tua richiesta:</LSimpleText>

                </Section>

                <Vspace qty={2.5}></Vspace>

                {!isRequiringDocuments && <>
                    <LSmallPageTitle>PATENTE ASSICURATO</LSmallPageTitle>
                    <Vspace qty={0.2}></Vspace>
                    <LSimpleTextSmall>Max 2 file:</LSimpleTextSmall>
                    <Vspace></Vspace>
                    <FronteRetroFilesUploadListCmp
                        initFronteRetroObj={communication.insuredLicenceDoc}
                        arrayDbPropSync={'insuredLicenceDoc'}
                        fileTypeFront={LinearFileTypeEnum.INSURED_LICENSE_FRONT}
                        fileTypeRear={LinearFileTypeEnum.INSURED_LICENSE_REAR}
                        alreadySentDocIds={alreadySentDocIds}
                        onPreUploadCallback={checkDimensionsFileAdded}
                        textLabelFront={"Aggiungi Fronte"}
                        textLabelRear={"Aggiungi Retro"}
                        adaptingDoubleLine={true}
                    />
                    <Vspace qty={1}></Vspace>
                </>}

                {!isRequiringDocuments && linearConducenteInfo?.insuredIsDriver === false && <>
                    <LSmallPageTitle>PATENTE CONDUCENTE</LSmallPageTitle>
                    <Vspace qty={0.2}></Vspace>
                    <LSimpleTextSmall>Max 2 file:</LSimpleTextSmall>
                    <Vspace></Vspace>
                    <FronteRetroFilesUploadListCmp
                        initFronteRetroObj={communication.driverLicenceList}
                        arrayDbPropSync={'driverLicenceList'}
                        fileTypeFront={LinearFileTypeEnum.DRIVER_LICENSE_FRONT}
                        fileTypeRear={LinearFileTypeEnum.DRIVER_LICENSE_REAR}
                        alreadySentDocIds={alreadySentDocIds}
                        onPreUploadCallback={checkDimensionsFileAdded}
                        textLabelFront={"Aggiungi Fronte"}
                        textLabelRear={"Aggiungi Retro"}
                        adaptingDoubleLine={true}
                    />
                </>}

                <Vspace qty={3}></Vspace>

                <LSmallPageTitle>DICHIARAZIONE DEI TESTIMONI</LSmallPageTitle>
                <Vspace qty={0.2}></Vspace>
                <LSimpleTextSmall>Max 2 file:</LSimpleTextSmall>
                <Vspace></Vspace>
                <FilesUploadListCmp
                    files={witnessesStatsList}
                    setFiles={setWitnessesStatsList}
                    fileType={"WITNESSES-STATEMENT"}
                    arrayDbPropSync={"witnessesStatsList"}
                    companyName={communication?.companyName}
                    maxLimit={2}
                    alreadySentDocIds={alreadySentDocIds}
                    onPreUploadCallback={checkDimensionsFileAdded}
                />

                <Vspace qty={3}></Vspace>

                <LSmallPageTitle>DOCUMENTO D'IDENTITÀ DEI TESTIMONI</LSmallPageTitle>
                <Vspace></Vspace>
                <FronteRetroList
                    listObj={communication.witnessesDocsList}
                    arrayDbPropSync={'witnessesDocsList'}
                    fileTypeFront={LinearFileTypeEnum.ID_WITNESSES_FRONT}
                    fileTypeRear={LinearFileTypeEnum.ID_WITNESSES_REAR}
                    alreadySentDocIds={alreadySentDocIds}
                />
                <Vspace qty={2}></Vspace>

                <LSmallPageTitle>ALTRI DOCUMENTI</LSmallPageTitle>
                <LSimpleText>Max 6 file:</LSimpleText>
                <Vspace></Vspace>
                <FilesUploadListCmp
                    files={otherDocsList}
                    setFiles={setOtherDocsList}
                    fileType={"OTHER-DOCUMENTS"}
                    arrayDbPropSync={"otherDocsList"}
                    companyName={communication?.companyName}
                    maxLimit={6}
                    alreadySentDocIds={alreadySentDocIds}
                    onPreUploadCallback={checkDimensionsFileAdded}
                />

                <Vspace qty={3}></Vspace>

                <LSmallPageTitle>IBAN PROPRIETARIO VEICOLO</LSmallPageTitle>
                <LSimpleText className="left">Se verrà accertato che hai diritto al risarcimento del sinistro, procederemo all’accredito su questo <strong style={{ color: "#575757" }}>conto intestato al proprietario del veicolo</strong>.</LSimpleText>
                <Vspace></Vspace>
                <InputCmp
                    disabled={disabledInput}
                    value={iban || ''}
                    setValue={(val: string) => setIban(val.replace(/\s/g, '').toUpperCase())}
                    name={`contact-info-iban`}
                    labelClassName="marked"
                    className={`contact-info small ${companyName}`}
                    containerClassName="mb"
                    errors={formErrors}
                    companyName={companyName}
                    placeholder="Facoltativo"
                />

                <Vspace qty={2}></Vspace>

                <Section linear={true}>
                    <LNextButton disabled={(iban?.length > 0 && !isValidIBAN(iban))} onClick={goToNextStepHandler}>SALVA E PROSEGUI</LNextButton>
                    <Vspace qty={2}></Vspace>
                    <SecondChoiseButton linear={true} onClick={goToHelp}>Hai bisogno di aiuto?</SecondChoiseButton>
                </Section>

                <LinearFooterCmp />

            </PageContainerCmp>
        </>

    )
}

export default OptionalDocumentsPageLinear